import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ChipsFilterService } from '@models';
import { StudyFilterService } from '@services';

@Component({
  selector: 'chips-list',
  templateUrl: './chips-list.component.html',
  styleUrls: ['./chips-list.component.scss']
})
export class ChipsListComponent implements OnInit {
  @Input() filterService: ChipsFilterService = inject(StudyFilterService);
  @Input() displayedColumns: string[] = [
    'therapeuticArea',
    'studyPhase',
    'studyStage',
    'bcNumber',
    'accelerator',
    'nextMilestone',
    'indication',
    'drugName',
    'studyStatus',
    'fspIndicator',
    'milestoneStatus'
  ];

  chipsList: Record<string, string[]> = {};
  objectKeys = Object.keys;

  private destroyRef: DestroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.filterService.filterState$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((filterState) => {
        this.chipsList = {};
        const appliedFilters = filterState.appliedFilters;

        const columnsToProcess = this.isStudyFilterService()
          ? this.displayedColumns
          : Object.keys(appliedFilters);

        this.processFilterColumns(appliedFilters, columnsToProcess);
      });
  }

  removeFilter(column: string, value: string, event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.filterService.removeFilter(column, value);
  }

  private processFilterColumns(
    appliedFilters: Record<string, Set<string>>,
    columns: string[]
  ): void {
    for (const column of columns) {
      if (appliedFilters[column] && appliedFilters[column].size > 0) {
        this.chipsList[column] = Array.from(appliedFilters[column]);
      }
    }
  }

  private isStudyFilterService(): boolean {
    return this.filterService instanceof StudyFilterService;
  }
}
